import { mapGetters } from 'vuex';
import { checkPartnerReferWithZmCoupon } from '@/views/config/partner-refer/helper/validator';

export default {
  computed: {
    ...mapGetters([
      'partnerReferProductNames',
      'inEligibleErrorObjectForPartner',
      'showInEligibleMsg',
      'isEligibleForPartner',
      'partnerRefer',
      'isFromPartnerRefer',
      'couponState',
    ]),
    mx_trackingPartnerName() {
      return `partner promo - ${this.partnerRefer.partnerName ?? 'partner name'}`;
    },
    mx_trackingInEligibleErrorReason() {
      if (!this.isEligibleForPartner) {
        return this.inEligibleErrorObjectForPartner?.tracking;
      }

      if (this.isEligibleForPartner && !checkPartnerReferWithZmCoupon(this.couponState) && this.couponState?.couponCode) {
        return 'applied with zoom coupon - not allow with zm coupon';
      }

      return '';
    },
    mx_trackingPartnerImpressionReason() {
      if (this.isFromPartnerRefer) {
        return this.showInEligibleMsg ?
          `${this.partnerReferProductNames} - ineligible offer impression - ${this.mx_trackingInEligibleErrorReason}` :
          `${this.partnerReferProductNames} - offer impression`;
      }

      return '';
    },
    mx_trackingPartnerOfferDetailReason() {
      return this.showInEligibleMsg ?
        `${this.partnerReferProductNames} - ineligible offer details - ${this.mx_trackingInEligibleErrorReason}` :
        `${this.partnerReferProductNames} - offer details`;
    },
  },
};
